(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('basketBar', function($q, tripService, $routeParams, basketStore, broker, customCurrencyFilter, bookingService, arrayUtil) {
    return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=BasketBar',
            scope: {
                hideButton: '=',
                buttonHandler: '&',
                buttonDisabler: '&',
                isDeposit: '=?'
            },
            link(scope) {
                if ($routeParams.pb) {
                    return;
                }

                scope.costBreakdowns = [];
                scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;

                broker.subscribe('basketBarDirective', 'feesUpdated', _setPaymentTotalPlusFees);

                function _setPaymentTotalPlusFees(fees) {
                    const cardFee = (fees && fees.data && fees.data.CardHandlingFee) || 0;
                    //creating clean data object
                    scope.fees = fees && fees.data ? { data: angular.copy(fees.data) } : null;
                    scope.totalDepositWithCardFee = (scope.deposit || 0) + cardFee;
                }


                tripService.getTrip($routeParams.tripId).then(function(trip) {
                    function getCostbreakdowns() {
                        const reqs = [basketStore.totalDeposit(trip.BasketId, $routeParams.productId),
                                basketStore.costBreakdownGrouped(trip.BasketId),
                                basketStore.getTaxAdjustmentValue(trip.BasketId)];
                        if (trip.BookingId) {
                            reqs.push(bookingService.getBooking(trip.BookingId));
                        }

                        $q.all(reqs).then(function([totalDeposit, costBreakdownGrouped, taxAdjustments, booking]) {

                            const costType = {
                                Unknown: 0,
                                Accommodation: 1,
                                Discount: 20,
                                AccommodationCancellationProtection: 21,
                                AccommodationLocalFeesAndTaxes: 22,
                                AccommodationExtraTransfer: 23,
                                AccommodationExtraEvent: 24,
                                AccommodationExtraAttraction: 25,
                                AccommodationExtra: 26,
                            };

                            if (!costBreakdownGrouped.isPackage && (trip.TripType === tripService.tripTypes.Hotel)) {

                                const { costBreakdown = [] } = costBreakdownGrouped[0] || {};

                                const extraCostItems = costBreakdown.filter(cost => {
                                    const match = _.get(cost, 'ParentId') && _.get(cost, 'TypeId') ===
                                    (costType.AccommodationExtraTransfer || costType.AccommodationExtraEvent
                                        || costType.AccommodationExtraAttraction || costType.AccommodationExtra || costType.AccommodationExtra || costType.AccommodationLocalFeesAndTaxes || costType.AccommodationCancellationProtection || costType.Discount);
                                        return match;

                                    }).filter(extra => extra);

                                const roomCostItems = costBreakdown.filter(cost => !_.get(cost, 'ParentId')
                                && _.get(cost, 'TypeId') === costType.Accommodation).map((room, LinkId) => {
                                    return { ...room, LinkId };
                                });

                                if (extraCostItems && extraCostItems.length > 0 && roomCostItems && roomCostItems.length > 0) {

                                    const updatedRoomCostItems = roomCostItems.map(room => {
                                        return { RoomId: room.Id, RoomDescription: room.Description };
                                    });

                                    const enhancedExtras = extraCostItems.map(extras => {
                                        return { ...extras, ...updatedRoomCostItems.find(acc => acc.RoomId === extras.ParentId) };
                                    });

                                    const updatedExtrasCostItems = enhancedExtras.map((extra, LinkId) => {
                                        const splitDescription = _.get(extra, 'RoomDescription').split('(');

                                        const Description = splitDescription[1] ? `${extra.Description} (${splitDescription[1]}` : extra.Description;
                                        return {
                                            ...extra,
                                            Description,
                                            LinkId,
                                        };
                                    });

                                    const updatedCostBreakdown = [...roomCostItems, ...updatedExtrasCostItems];
                                    const costsSortedById = updatedCostBreakdown.sort((a, b) => (a.LinkId >= b.LinkId) ? 1 : -1);

                                    costBreakdownGrouped[0].costBreakdown = costsSortedById;
                                }
                            }

                            scope.costBreakdowns = costBreakdownGrouped;
                            scope.total = costBreakdownGrouped.total;
                            scope.taxAdjustment = taxAdjustments;
                            scope.isPackage = costBreakdownGrouped.isPackage;

                            let deposit = totalDeposit;
                            if (booking) {
                                deposit += booking.UserData.PaymentDetails.DepositAmount;
                            }
                            scope.deposit = deposit;
                            if (scope.binRangeDiscount != null) {
                                scope.total -= scope.binRangeDiscount.DiscountValue;
                                if (!scope.isDeposit) {
                                    scope.deposit -= scope.binRangeDiscount.DiscountValue;
                                }
                            }
                            tripService.getCurrency($routeParams.tripId).then(currency => {
                                scope.currency = currency;
                                scope.totalDeposit = customCurrencyFilter(scope.deposit, currency);
                                _setPaymentTotalPlusFees(scope.fees);
                            });
                        });

                        // persist any open content panel
                        const i = arrayUtil.indexOf(scope.costBreakdowns, function(cb) {
                            return cb.open;
                        });
                        if (i >= 0) {
                            scope.costBreakdowns[i].open = true;
                        }
                    }

                    getCostbreakdowns();

                    broker.subscribe('basketBarDirective', 'basketUpdated', _.debounce(getCostbreakdowns, 100));
                    broker.subscribe('basketBarDirective', 'paymentDataUpdated', _.debounce(getCostbreakdowns, 100));

                    broker.subscribe('basketBarDirective', 'discountUpdated', _setBinRangeDiscount);

                    function _setBinRangeDiscount(discount) {
                        if (discount.data != null) {
                            scope.binRangeDiscount = discount.data[0];
                        } else {
                            scope.binRangeDiscount = null;
                        }
                        getCostbreakdowns();
                    }

                    scope.$on('$destroy', () => {
                        broker.unsubscribe('basketBarDirective');
                    });
                });

                scope.sectionClass = function(index) {
                    return scope.costBreakdowns[index].open ? 'expanded' : '';
                };

                scope.toggleSection = function(index) {
                    scope.costBreakdowns.forEach(function(cb, i) {
                        if (i !== index) {
                            cb.open = false;
                        }
                    });

                    scope.costBreakdowns[index].open = !scope.costBreakdowns[index].open;
                };
            }
        };
    }
);
})();
